/** Route state + timing for marketing ↔ auth transitions */
export const MARKETING_TRANSITION_MS = 260;

export const FROM_MARKETING_STATE = { fromMarketing: true };
export const TO_MARKETING_STATE = { toMarketing: true };
export const AUTH_SWITCH_STATE = { authSwitch: true };
